
 <div class="loader-logo" id="nexg_ngb-progressbar">
      <div class="loader-logo-animation">
        <img src="../../../../assets/img/logo.png" />
        <span></span>
      </div>
    </div>
  
<app-header *ngIf="!hideHeaderFooter"></app-header>
<router-outlet></router-outlet>
<!-- <ng-http-loader [spinner]="skThreeBounce" *ngIf="activeComponent != 'DetailEpisodeComponent'"></ng-http-loader> -->
<app-footer *ngIf="!hideHeaderFooter && delayFooter"></app-footer>